
/* injects from baggage-loader */

// AVATARS

import avatar1 from '_images/avatars/01.png';
import avatar2 from '_images/avatars/02.png';
import avatar3 from '_images/avatars/03.png';
import avatar4 from '_images/avatars/04.png';

import active_avatar1 from '_images/avatars/01_active.png';
import active_avatar2 from '_images/avatars/02_active.png';
import active_avatar3 from '_images/avatars/03_active.png';
import active_avatar4 from '_images/avatars/04_active.png';

import thumb1 from '_images/avatars/01_thumb.png';
import thumb2 from '_images/avatars/02_thumb.png';
import thumb3 from '_images/avatars/03_thumb.png';
import thumb4 from '_images/avatars/04_thumb.png';


export const avatars = [
  avatar1,
  avatar2,
  avatar3,
  avatar4
]

export const avatars_active_status = [
  active_avatar1,
  active_avatar2,
  active_avatar3,
  active_avatar4
]

export const thumbs = [
  thumb1,
  thumb2,
  thumb3,
  thumb4
]


// Puzzle

import p1 from '_images/packs/p1.png';
import p2 from '_images/packs/p2.png';
import p3 from '_images/packs/p3.png';
import p4 from '_images/packs/p4.png';
import p5 from '_images/packs/p5.png';
import p6 from '_images/packs/p6.png';

export const Puzzle = [
  p1,
  p2,
  p3,
  p4,
  p5,
  p6
]


// Numerals
export const NumeralsI18n = {
  female: {    
    1: 'uma',
    2: 'duas',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  },
  male: {
    1: 'um',
    2: 'dois',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  }  
}


// Types

export const FormTypes = {
  'rect': 1,
  'circle': 2,
  'triangle': 3
}

export const FormSizes = {
  'small': 1,
  'normal': 2,
  'big': 3
}

export const FormColors = {
  'red': 1,
  'blue': 2,
  'yellow': 3
}


// WEBPACK FOOTER //
// ./src/app/index.const.js